<div kalDialogContent
     [kalLoading]="loading$ | async">

    <app-shared-mail [formControl]="formControl">
    </app-shared-mail>

</div>

<div class="gup-C-validationArea gup-O-list"
     kalDialogFooter>

    <div class="gup-O-list__item">
        <kal-button (click)="sendMail()"
                    [disabled]="formControl.invalid || (loading$ | async)"
                    id="shared_publipostage_button_sendMail"
                    kalTheme="primary">
            Envoyer l'e-Mail
        </kal-button>
    </div>

    <div class="gup-O-list__item">
        <kal-button (click)="close()"
                    id="shared_publipostage_button_close"
                    kalTheme="secondary">
            Fermer sans envoyer
        </kal-button>
    </div>

</div>
